import CustomerAddressesStore from '../store/CustomerAddressesStore';
import { fetchFromJson } from './fetchFromJson';

const db = new CustomerAddressesStore('custumerAddressesStore');

const updateCache = 'customerAddresses_updateCache';
const getUpdateCache = (data) => data.addresses;
const toast = 'Customer Addresses Updated';
const entityName = 'customerAddresses';

export default (WrappedComponent) => fetchFromJson({
  WrappedComponent,
  getUpdateCache,
  db,
  updateCache,
  toast,
  entityName,
});
